import config from '../config';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
      </section>

      <div className="contact-container">
        <div className="contact-info-section">
          <div className="info-card">
            <div className="info-icon">📍</div>
            <h3>Visit Us</h3>
            <p>1st Floor, Medhi Building Tangra Satra Path</p>
            <p>GS Road Rukmini Gaon</p>
          </div>

          <div className="info-card">
            <div className="info-icon">📞</div>
            <h3>Call Us</h3>
            <p>Phone: {config.contact.phone}</p>
            <p>Landline: +91 8011110269</p>
          </div>

          <div className="info-card">
            <div className="info-icon">💬</div>
            <h3>WhatsApp</h3>
            <p>{config.contact.phone}</p>
            <p>Quick responses guaranteed</p>
          </div>

          <div className="info-card">
            <div className="info-icon">✉️</div>
            <h3>Email Us</h3>
            <p>{config.contact.email}</p>
            <p>support@{config.contact.email.split('@')[1]}</p>
          </div>

          <div className="info-card">
            <div className="info-icon">🕒</div>
            <h3>Working Hours</h3>
            <p>Monday - Sunday</p>
            <p>9:00 AM - 9:00 PM</p>
          </div>

          <div className="info-card">
            <div className="info-icon">🌐</div>
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
            </div>
          </div>
        </div>
      </div>

      <div className="booking-cta-section">
        <div className="booking-cta-content">
          <h2>Ready to Book Your Appointment?</h2>
          <p>Booking Available via Phone & WhatsApp • Advance Appointment Recommended</p>
          <div className="cta-buttons">
            <a href="tel:+919876543210" className="cta-button primary">Call Now</a>
            <a href="https://wa.me/916000503903" target="_blank" rel="noopener noreferrer" className="cta-button secondary">WhatsApp</a>
          </div>
        </div>
      </div>

      <div className="map-section">
        <h2>Find Us on Map</h2>
        <div className="map-container">
          <iframe
            title="Aura Ayurveda & Wellness Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.0234567890123!2d91.8023984!3d26.1349933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a59f5517002e9%3A0x88c4b4d7c4021fd2!2sAura%20Ayurveda%20%26%20Wellness!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0, borderRadius: '15px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
